import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import StandingsSelect from "../headtohead/StandingsSelect";

//HOOKS
import useHeadToHead from "../../hooks/useHeadToHead";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

function getBool(val) {
   if (val) {
      return !!JSON.parse(String(val).toLowerCase());
   }
}

export default function HeadToHeadGrid({
   loadDownloader,
   clearDownloader
}) {

   const [
      notification,
      allHeadToHead,
      headToHead,
      show,
      runTimestamp,
      { getAllHeadToHead },
   ] = useHeadToHead();

   const [standingsId, setStandingsId] = useState(0);
   const [standingsRound, setStandingsRound] = useState("MostRecent");

   useEffect(() => {
      getAllHeadToHead();
   }, []);

   const refreshGrid = () => {
      getAllHeadToHead();
      clearDownloader();
   };

   let columns;
   let initialState;

   columns = [
      {
         field: "id",
         headerName: "Head To Head Id",
         editable: false,
         width: 100,
         filterable: false,
      },
      {
         field: "Player1",
         headerName: "Player 1",
         editable: false,
         width: 200,
         filterable: false,
         valueGetter: (params) => params.row.Player1 && params.row.Player1.PlayerName ? params.row.Player1.PlayerName : "-NONE-",
      },
      {
         field: "Player2",
         headerName: "Player 2",
         editable: false,
         width: 200,
         filterable: false,
         valueGetter: (params) => params.row.Player2 && params.row.Player2.PlayerName ? params.row.Player2.PlayerName : "-NONE-",
      },
      {
         field: "StandingsId",
         headerName: "Round Standings",
         editable: false,
         width: 300,
         filterable: false,
         renderCell: (params) => (
            <StandingsSelect
               disabled={true}
               selected={params.row.StandingsId}
               callback={console.log}
            />
         )
      },
      {
         field: "PreviewHeadToHead",
         headerName: "",
         editable: false,
         width: 300,
         filterable: false,
         sortable: false,
         renderCell: (params) => (
            <>
               <Button
                  size='small'
                  onClick={() => {
                     const roundId = standingsId === 0 || standingsId === '0' ? 0 : (standingsId === 9999999 || standingsId === '9999999' ? 9999999 : Number(standingsId));
                     loadDownloader("headtohead", params.row.id, roundId, "HeadToHead_" + (params.row.Player1 && params.row.Player1.PlayerName ? params.row.Player1.PlayerName.replace(/[^a-zA-Z]/g, "") : "none") + "_vs_" + (params.row.Player2 && params.row.Player2.PlayerName ? params.row.Player2.PlayerName.replace(/[^a-zA-Z]/g, "") : "none") + "_" + standingsRound);
                  }}
                  sx={{ mr: 1 }}
               >
                  LOAD HEAD TO HEAD
               </Button>
            </>
         ),
      }
   ];

   initialState = {
      sorting: {
         // sortModel: [{ field: "LastName", sort: "asc" }],
      },
      columns: {
         columnVisibilityModel: {
            id: false
         },
      },
   };

   return (
      <>
         <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
            <Typography variant="h3" component="div" sx={{ textTransform: "uppercase" }}>Head To Head</Typography>
            <Button onClick={refreshGrid} color="error" variant="outlined">Refresh Data</Button>
         </Stack>
         
         <Box sx={{ py: 2, px: 4, backgroundColor: "#fff", mb: 2 }}>
            <StandingsSelect
               backgroundColor={null}
               selected={standingsId}
               callback={(data) => {
                  if (data && data.id !== null && data.id !== undefined) {
                     const roundId = data.id === '0' ? 0 : (data.id === '9999999' ? 9999999 : Number(data.id));
                     setStandingsId(roundId);
                     setStandingsRound(data.value || "MostRecent");
                     clearDownloader();
                  }
               }}
            />
         </Box>
         
         <Box height={400} width="100%">
            {allHeadToHead && (
               <DataGrid
                  initialState={initialState}
                  sx={{ backgroundColor: "#efefef" }}
                  rows={allHeadToHead}
                  rowHeight={40}
                  columns={columns}
                  rowsPerPageOptions={[100, 200, 300, 1000, 5000]}
                  components={{ Toolbar: GridToolbar }}
                  componentsProps={{
                     toolbar: {
                        printOptions: {
                           disableToolbarButton: true,
                        },
                     },
                  }}
                  disableColumnSelector
                  disableDensitySelector
                  disableSelectionOnClick
               />
            )}
         </Box>
      </>
   );
}
